import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import axios from './config'
import VueAxios from 'vue-axios'
import VueSweetAlert from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import firebase from './service/firebase';

var firebaseConfig = {
  apiKey: "AIzaSyCQslelayr6j-UPULhDRPolUJSN3VC6YzA",
  authDomain: "delidagon34.firebaseapp.com",
  projectId: "delidagon34",
  storageBucket: "delidagon34.appspot.com",
  messagingSenderId: "544005771058",
  appId: "1:544005771058:web:5a4e89e7b4c45e3c94512b",
  measurementId: "G-MTY0D304VP"
};
//Initialize Firebase
firebase.initializeApp(firebaseConfig);


loadFonts()

const app = createApp(App)
app.use(VueAxios, axios)
app.use(VueSweetAlert)
app.use(router)
app.use(store)
app.use(vuetify)
app .mount('#app')


// app.filter("numberFormat", function (value) {
//   return numeral(value).format('0,0');
// });

import gAuthPlugin from 'vue3-google-oauth2';
//let gauthClientId = '544005771058-m7fe06vrsvthqbb5gtrikr532vmr41mn.apps.googleusercontent.com';
let gauthClientId = '544005771058-m7fe06vrsvthqbb5gtrikr532vmr41mn.apps.googleusercontent.com';

app.use(gAuthPlugin,{
clientId:gauthClientId,
scope:'email',
prompt:'consent',
})
